
    <form [formGroup]="form" fxLayout="column">
      <mat-form-field class="example-full-width">
        <textarea
          matInput
          [placeholder]="'leave a comment' | translate | sentancecase"
          formControlName="text"
        ></textarea>
      </mat-form-field>
    </form>
    <div fxLayout="row" fxLayoutAlign="end center">
      <button
        mat-raised-button
        color="primary"
        [disabled]="!form.valid"
        (click)="onPost()"
      >
        {{ 'post' | translate | titlecase }}
      </button>
    </div>
  